stimulusApp.register(
  "cruise-search-sort",
  class extends Stimulus.Controller {
    static targets = ["trigger", "menu"]

    toggle() {
      const opened = this.menuTarget.classList.toggle("sort-by--menu_opened")

      this.triggerTarget.setAttribute("aria-expanded", opened)
    }

    closeOnOutsideClick(event) {
      if (!this.hasMenuTarget || this.element.contains(event.target)) return

      this.#close()
    }

    submit() {
      this.element.requestSubmit()
    }

    #close() {
      this.menuTarget.classList.remove("sort-by--menu_opened")
      this.triggerTarget.setAttribute("aria-expanded", "false")
    }
  },
)
